var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ci-button-section row"},[_c('div',{staticClass:"col-9"},[_vm._t("header"),_vm._t("description")],2),_c('div',{staticClass:"col-3 align-self-center"},[_vm._t("action")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }